/**
 * Client parity for `config/exploreUnknownLeveling.json` milestone preview.
 * Used when `exploreUnknownXpGrant.nextLevelMilestoneBonus` is absent (older server payloads).
 */

const MILESTONE_LEVELS = Object.freeze([
  5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
]);

/** @type {Readonly<Record<string, { icon: string, i18nKey: string, bonusId: string }>>} */
const MILESTONE_BONUSES = Object.freeze({
  '5': { bonusId: 'diplomatic_accords_strategic_coordination_l5', icon: '/images/strategic_coordination.jpg', i18nKey: 'levelBonus5' },
  '10': { bonusId: 'childhood_memories_l10', icon: '/images/happy.jpg', i18nKey: 'levelBonus10' },
  '15': { bonusId: 'better_order_rewards_increase_rarity_by_10_l15', icon: '/images/any_faction.jpg', i18nKey: 'levelBonus15' },
  '20': { bonusId: 'hearts_l20', icon: '/images/heart.jpg', i18nKey: 'levelBonus20' },
  '25': { bonusId: 'emergency_protocol_l25', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus25' },
  '30': { bonusId: 'you_get_a_legendary_order_l30', icon: '/images/any_faction.jpg', i18nKey: 'levelBonus30' },
  '35': { bonusId: 'dark_knowledge_l35', icon: '/images/dark_knowledge.jpg', i18nKey: 'levelBonus35' },
  '40': { bonusId: 'choose_path_l40', icon: '/images/shadowverse_desert.jpg', i18nKey: 'levelBonus40' },
  '45': { bonusId: 'rewrite_experience_l45', icon: '/images/retry.jpg', i18nKey: 'levelBonus45' },
  '50': { bonusId: 'natural_darkness_reduction_l50', icon: '/images/sad.jpg', i18nKey: 'levelBonus50' },
  '55': { bonusId: 'natural_health_increase_l55', icon: '/images/weak_heart.jpg', i18nKey: 'levelBonus55' },
  '60': { bonusId: 'more_memories_l60', icon: '/images/plan_ahead.jpg', i18nKey: 'levelBonus60' },
  '65': { bonusId: 'better_hearts_l65', icon: '/images/heart.jpg', i18nKey: 'levelBonus65' },
  '70': { bonusId: 'fewer_emergency_protocol_fragments_l70', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus70' },
  '75': { bonusId: 'fewer_rewrite_experience_fragments_l75', icon: '/images/retry.jpg', i18nKey: 'levelBonus75' },
  '80': { bonusId: 'automatic_memory_collection_l80', icon: '/images/happy.jpg', i18nKey: 'levelBonus80' },
  '85': { bonusId: 'automatic_emergency_protocol_collection_l85', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus85' },
  '90': { bonusId: 'automatic_hearts_collection_l90', icon: '/images/heart.jpg', i18nKey: 'levelBonus90' },
  '95': { bonusId: 'automatic_rewrite_experience_collection_l95', icon: '/images/retry.jpg', i18nKey: 'levelBonus95' },
  '100': { bonusId: 'learn_the_truth_about_negara_olanea_l100', icon: '/images/402.jpg', i18nKey: 'levelBonus100' },
});

/**
 * @param {number} currentLevel
 * @returns {{ level: number, bonusId: string, icon: string, i18nKey: string }|null}
 */
export function getImmediateNextMilestoneBonusFromLevel(currentLevel) {
  const lv = Number(currentLevel);
  if (!Number.isInteger(lv) || lv < 1) {
    return null;
  }
  const next = lv + 1;
  if (!MILESTONE_LEVELS.includes(next)) {
    return null;
  }
  const meta = MILESTONE_BONUSES[String(next)];
  if (!meta) {
    return null;
  }
  return { level: next, ...meta };
}

export { MILESTONE_LEVELS, MILESTONE_BONUSES };
